import React from "react";

function Colors_2020() {
  return (
    <div>
      <h1>Colors_2020 Component</h1>
      <p>This is the Colors 2020 tutorial page content.</p>
    </div>
  );
}

export default Colors_2020;
